
const format = (text) => {
	const replacementActions = [
		{ /* strong */
			pattern: '(?:\\*)([\\s\\S]*?)(?:\\*)',
			replace: '<strong>$1</strong>',
		},
		{ /* Newline */
			pattern: '(?:\\r|\\n|\\r\\n)',
			replace: '<br>',
		},
	];

	return replacementActions.reduce((workingData, action) =>
	  workingData.replace(new RegExp(action.pattern, 'gm'), action.replace)
	, text);
};

export default { format };



// WEBPACK FOOTER //
// ./src/helper/textFormatHelper.js